// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  --btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  --btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
  --dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;
}

.switch-custom {
  --switch-scale: 1;
  display: flex;
  align-items: center;
  gap: calc(6px * var(--switch-scale));
  -webkit-user-select: none;
          user-select: none;
}
.switch-custom__label {
  font-weight: 600;
  font-size: calc(1.6em * var(--switch-scale));
  opacity: 0.55;
}
.switch-custom__label.active {
  opacity: 1;
}
.switch-custom__toggle {
  position: relative;
  display: inline-block;
  width: calc(52px * var(--switch-scale));
  height: calc(30px * var(--switch-scale));
}
.switch-custom__toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch-custom__toggle input:focus-visible + .switch-custom__slider {
  box-shadow: 0 0 0 3px rgba(91, 133, 194, 0.25);
}
.switch-custom__slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  border: calc(3px * var(--switch-scale)) solid #5b85c2;
  transition: 0.2s ease;
  border-radius: 999px;
}
.switch-custom__slider::before {
  position: absolute;
  content: "";
  height: calc(16px * var(--switch-scale));
  width: calc(16px * var(--switch-scale));
  left: calc(6px * var(--switch-scale));
  top: calc(4px * var(--switch-scale));
  background-color: transparent;
  border: calc(3px * var(--switch-scale)) solid #5b85c2;
  transition: 0.2s ease;
  border-radius: 999px;
}
.switch-custom__toggle input:checked + .switch-custom__slider {
  background-color: transparent;
}
.switch-custom__toggle input:checked + .switch-custom__slider::before {
  transform: translateX(calc(22px * var(--switch-scale)));
}
.switch-custom--disabled .switch-custom__label {
  color: #98b1d3;
  opacity: 1;
}
.switch-custom--disabled .switch-custom__slider,
.switch-custom--disabled .switch-custom__slider::before {
  border-color: #98b1d3;
}
.switch-custom--disabled .switch-custom__slider {
  cursor: not-allowed;
}
@media screen and (min-width: 1440px) {
  .switch-custom {
    font-size: 14px;
    line-height: 16px;
  }
}

.switch-currency {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  -webkit-user-select: none;
          user-select: none;
}
.switch-currency span {
  font-size: 1rem;
  line-height: 1.1rem;
  font-style: normal;
  font-weight: 500;
}
.switch-currency label {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 18px;
}
.switch-currency label span {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  border: 1px solid #426ba6;
  transition: 0.2s ease;
  border-radius: 999px;
}
.switch-currency label span::before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 2px;
  top: 1px;
  background-color: #426ba6;
  border: 1px solid #426ba6;
  transition: 0.2s ease;
  border-radius: 50px;
}
.switch-currency label input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch-currency label input:focus-visible + .switch-custom__slider {
  box-shadow: 0 0 0 3px rgba(91, 133, 194, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/Components/App/vars.scss","webpack://./src/utilities/Buttons/SwitchComponent/SwitchCustom.scss"],"names":[],"mappings":"AA8CA;EACE,sDAAA;EACA,0DAAA;EACA,2GAAA;EACA,kDAAA;AC7CF;;AAJA;EAGE,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;UAAA,iBAAA;AAIF;AAFE;EACE,gBAAA;EACA,4CAAA;EACA,aAAA;AAIJ;AAFI;EACE,UAAA;AAIN;AAAE;EACE,kBAAA;EACA,qBAAA;EACA,uCAAA;EACA,wCAAA;AAEJ;AAAI;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAEN;AAAM;EACE,8CAAA;AAER;AAGE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,qDAAA;EACA,qBAAA;EACA,oBAAA;AADJ;AAGI;EACE,kBAAA;EACA,WAAA;EACA,wCAAA;EACA,uCAAA;EACA,qCAAA;EACA,oCAAA;EACA,6BAAA;EACA,qDAAA;EACA,qBAAA;EACA,oBAAA;AADN;AAKE;EACE,6BAAA;AAHJ;AAME;EACE,uDAAA;AAJJ;AAQI;EACE,cAvEoB;EAwEpB,UAAA;AANN;AASI;;EAEE,qBA7EoB;AAsE1B;AAUI;EACE,mBAAA;AARN;AAYE;EAvFF;IAwFI,eAAA;IACA,iBAAA;EATF;AACF;;AAYA;EAEE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,yBAAA;UAAA,iBAAA;AAVF;AAYE;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAVJ;AAaE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAXJ;AAYI;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;AAVN;AAYM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,yBDtHI;ECuHJ,yBAAA;EACA,qBAAA;EACA,mBAAA;AAVR;AAaI;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAXN;AAaM;EACE,8CAAA;AAXR","sourcesContent":["$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$borderColorLight: #dae1ec;\n$accentFilterColor: #ff8040;\n$accentColor: #b72025;\n$warningColor: #d3c71c;\n$succesColor: #00dbbb;\n$accentTableRowColor: #ecc0c1;\n$filtersBgColor: #d6dfea71; //#d6dfea\n$filterTitleColor: #d6dfea93;\n$textColor: #426ba6;\n$filtersBorderColor: #426ba6;\n$deletedTextColor: #b72025;\n$iconFill: #829ec4;\n$logoIcon: #6d91c6;\n$activeBtnColor: rgba(218, 225, 236, 1);\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n$btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;\n$reactTableShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;\n$dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;\n$commonShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$commonShadowHover: rgba(67, 71, 85, 0.27) 1px 1px 0.25em, rgba(90, 125, 188, 0.05) 1px 0.3em 1em;\n\n$transition: ease;\n$transitionFunc: cubic-bezier(0.25, 1, 0.5, 1);\n$iconHoverTransition: cubic-bezier(0.22, 1, 0.36, 1);\n$commonTransition: 0.3s $transitionFunc;\n\n:root {\n  --filterBtnBoxShadow: #{$filterBtnBoxShadow};\n  --btnBoxShadow: #{$btnBoxShadow};\n  --btnHoverBoxShadow: #{$btnHoverBoxShadow};\n  --dividerShadow: #{$dividerShadow};\n}\n\n$main-font: \"Roboto\", sans-serif;\n\n$font-weights: (\n  \"Light\": 300,\n  \"Regular\": 400,\n  \"Medium\": 500,\n  \"Bold\": 700,\n);\n","@use \"../../../Components/App/vars.scss\" as v;\n.switch-custom {\n  $switch-color: #5b85c2;\n  $switch-disabled-color: #98b1d3;\n  --switch-scale: 1;\n\n  display: flex;\n  align-items: center;\n  gap: calc(6px * var(--switch-scale));\n  user-select: none;\n\n  &__label {\n    font-weight: 600;\n    font-size: calc(1.6em * var(--switch-scale));\n    opacity: 0.55;\n\n    &.active {\n      opacity: 1;\n    }\n  }\n\n  &__toggle {\n    position: relative;\n    display: inline-block;\n    width: calc(52px * var(--switch-scale));\n    height: calc(30px * var(--switch-scale));\n\n    input {\n      opacity: 0;\n      width: 0;\n      height: 0;\n\n      &:focus-visible + .switch-custom__slider {\n        box-shadow: 0 0 0 3px rgba(91, 133, 194, 0.25);\n      }\n    }\n  }\n\n  &__slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: transparent;\n    border: calc(3px * var(--switch-scale)) solid $switch-color;\n    transition: 0.2s ease;\n    border-radius: 999px;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      height: calc(16px * var(--switch-scale));\n      width: calc(16px * var(--switch-scale));\n      left: calc(6px * var(--switch-scale));\n      top: calc(4px * var(--switch-scale));\n      background-color: transparent;\n      border: calc(3px * var(--switch-scale)) solid $switch-color;\n      transition: 0.2s ease;\n      border-radius: 999px;\n    }\n  }\n\n  &__toggle input:checked + &__slider {\n    background-color: transparent;\n  }\n\n  &__toggle input:checked + &__slider::before {\n    transform: translateX(calc(22px * var(--switch-scale)));\n  }\n\n  &--disabled {\n    .switch-custom__label {\n      color: $switch-disabled-color;\n      opacity: 1;\n    }\n\n    .switch-custom__slider,\n    .switch-custom__slider::before {\n      border-color: $switch-disabled-color;\n    }\n\n    .switch-custom__slider {\n      cursor: not-allowed;\n    }\n  }\n\n  @media screen and (min-width: 1440px) {\n    font-size: 14px;\n    line-height: 16px;\n  }\n}\n\n.switch-currency {\n  $switch-color: v.$textColor;\n  display: flex;\n  align-items: flex-end;\n  gap: 4px;\n  user-select: none;\n\n  span {\n    font-size: 1rem;\n    line-height: 1.1rem;\n    font-style: normal;\n    font-weight: 500;\n  }\n\n  label {\n    position: relative;\n    display: inline-block;\n    width: 36px;\n    height: 18px;\n    span {\n      position: absolute;\n      cursor: pointer;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-color: transparent;\n      border: 1px solid $switch-color;\n      transition: 0.2s ease;\n      border-radius: 999px;\n\n      &::before {\n        position: absolute;\n        content: \"\";\n        height: 14px;\n        width: 14px;\n        left: 2px;\n        top: 1px;\n        background-color: v.$textColor;\n        border: 1px solid v.$textColor;\n        transition: 0.2s ease;\n        border-radius: 50px;\n      }\n    }\n    input {\n      opacity: 0;\n      width: 0;\n      height: 0;\n\n      &:focus-visible + .switch-custom__slider {\n        box-shadow: 0 0 0 3px rgba(91, 133, 194, 0.25);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
